// styled components
import tournament from "@tournaments";
import {
    Link,
    SingleLink,
    StyledDrawer
}
    from './styles';

// components
import { NavLink, useLocation } from 'react-router-dom';

// hooks
import { useSidebar } from '@contexts/sidebarContext';
import { useWindowSize } from 'react-use';
import { useAuth } from '@contexts/authContext';


const Sidebar = () => {
    const { links } = useAuth();

    const { open, setOpen } = useSidebar();

    const { pathname } = useLocation();
    const { width } = useWindowSize();

    // opciones según el rol; con varios roles una misma opción puede llegar repetida
    const pages = links
        .flatMap(link => link.pages)
        .filter((page, index, all) => all.findIndex(other => other.path === page.path) === index);

    // opciones públicas del final del menú; Nosotros y Formatos solo existen en algunos torneos
    const publicLinks = [
        { to: '/historial', icon: 'table', label: 'Torneos anteriores', match: '/historial' },
        { to: '/schedule', icon: 'calendar', label: 'Calendario' },
        //{ to: '/fase-final', icon: 'finish', label: 'Fase final' },
        tournament.nosotrosDocuments && { to: '/nosotros', icon: 'pdf', label: 'Nosotros' },
        tournament.formatosDocuments && { to: '/formatos', icon: 'pdf', label: 'Formatos' },
        { to: '/dian', icon: 'pdf', label: 'Documentos DIAN' },
    ].filter(Boolean);

    // `match`: la opción queda activa en todas sus subrutas (/historial/4)
    const isActive = item => (item.match ? pathname.startsWith(item.match) : pathname === item.to);

    return (
        <StyledDrawer
            variant={width < 1920 ? 'temporary' : 'permanent'}
            anchor="left"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            sx={{
                '& .MuiDrawer-paper': {
                    width: 250,
                }
            }}
            className="main-sidebar">
            <SingleLink className={pathname === '/' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/">
                    <Link className="h4">
                        <i className="icon icon-house" /> Inicio
                    </Link>
                </NavLink>
            </SingleLink>

            <nav className="d-flex flex-column g-8 flex-1">
                {
                    pages.map(page => (
                        <SingleLink key={page.path} className={pathname === page.path ? 'active' : ''} as="div">
                            <NavLink to={page.path}>
                                <Link className={`${pathname === page.path ? 'active' : ''} h4`}>
                                    {page.icon && <i className={`icon icon-${page.icon}`} />} {page.title}
                                </Link>
                            </NavLink>
                        </SingleLink>
                    ))
                }
            </nav>

            {
                publicLinks.map(item => (
                    <SingleLink key={item.to} className={isActive(item) ? 'pinned active' : 'pinned'} as="div">
                        <NavLink to={item.to}>
                            <Link className="h4">
                                <i className={`icon icon-${item.icon}`} /> {item.label}
                            </Link>
                        </NavLink>
                    </SingleLink>
                ))
            }
        </StyledDrawer>
    );
}

export default Sidebar;
